var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"an-14 greybtn--text demi-bold-text q-mt-sm"},[_vm._t("default"),_vm._v(" "),(_vm.onlyseconds)?_c('span',{staticClass:"timer"},[_vm._v(_vm._s(_vm.time))]):_c('span',{staticClass:"timer"},[_vm._v(_vm._s(_vm.prettyTime))]),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }